<template>
  <div class="Possessed-attestation-content-item-main" :class="{ 'Possessed-attestation-content-item-main-mobile': isMobile}">
    <div class="pic" :style="{ backgroundImage: `url(${data.Icon})` }"></div>
    <div class="names">
      <div>{{data.line1}}</div>
      <div>{{data.line2}}</div>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'PossessedAttestationContentItem',
    props: {
      data: {
        type: Object,
        default: () => {}
      }
    }
  };
</script>
<style lang="scss" scoped>
  .Possessed-attestation-content-item-main {
    border-radius: 0.03rem;
    width: 6.76rem;
    height: 4.27rem;
    background: #fff;
    box-shadow: 0 0.03rem 0.16rem 0.03rem rgb(226 226 226 / 59%);
    margin: 0 0.135rem;
    display: flex;
    flex-direction: column;
    // justify-content: center;
    align-items: center;
    .pic {
      width: 5.08rem;
      height: 2.83rem;
      margin-top: 0.33rem;
      background-repeat: no-repeat;
      background-size: 100%;
    }
    .names {
      font-size: 0.27rem;
      font-family: PingFangTC-Regular, PingFangTC;
      font-weight: 400;
      color: #000000;
      line-height: 0.37rem;
      letter-spacing: 1px;
      * {
        display: inline-block;
        margin-right: 0.1rem
      }
    }
  }
  .Possessed-attestation-content-item-main-mobile {
    margin: 0;
    border-radius: 0.07rem;
    width: 8.29rem;
    height: 9.36rem;
    box-shadow: 0px 10px 41px 10px rgba(226,226,226,0.59);
    .pic {
      width: 100%;
      height: 4.81rem;
      margin-top: 0.41rem;
    }
    .names {
      font-size: 0.72rem;
      color: rgba(0, 0, 0, 0.84);
      line-height: 1.02rem;
      letter-spacing: 0.01rem;
      text-align: center;
      margin-top: .31rem;
      * {
        display: block;
        margin-right: 0;
      }
    }
  }
</style>
